export default () => {
    return document.querySelector('#real-root') || document.querySelector('#root') || document.body
}
